export default __webpack_public_path__ + "static/media/antelope-7-thumbnail.eb9f4c78.jpg";